<template>
  <div>
    <CollectionView :endpoint="utilities.path('communities/@/roles', communityId)" searchable v-model:reload="reload" :orderable="[{key:'name', name: translate('name')}]">
      <template v-slot:header>
        <div class="d-flex align-items-center justify-content-between">
          <h4 class="mb-0">{{ translate("roles") }}</h4>
          <ButtonView type="normal" color="primary" @click="creating = true">
            {{ translate("create") }}
          </ButtonView>
        </div>
      </template>
      <template v-slot:content="{ items }">
        <div class="card">
          <div class="table-responsive">
            <div class="table">
              <div class="table-header">
                <div class="table-header-cell">{{ translate("name") }}</div>
                <div class="table-header-cell">{{ translate("color") }}</div>
                <div class="table-header-cell">{{ translate("actions") }}</div>
              </div>
              <div class="table-body">
                <a class="table-row" v-for="item in items" :key="item.id" @click="viewing = item">
                  <div class="table-column">
                    {{ item.name }}
                  </div>
                  <div class="table-column">
                    <i class="fas fa-circle fa-fw" :style="{ color: item.color }"></i>
                  </div>
                  <div class="table-column">
                    <div class="d-flex align-items-center g-2">
                      <ButtonView type="soft" color="primary" size="small" @click.prevent.stop="editing = item">
                        <i class="fas fa-edit"></i>
                      </ButtonView>
                      <TargetedModalHttpFormView size="small" :endpoint="utilities.path('roles/@', item.id)" method="delete" @success="reload = true">
                        <template v-slot:target="{ show }">
                          <ButtonView type="soft" color="danger" size="small" @click.prevent.stop="show">
                            <i class="fas fa-trash"></i>
                          </ButtonView>
                        </template>
                        <template v-slot:form="{ submit, loading, hide }">
                          <h2 class="mb-4">{{ item.name }}</h2>
                          <SpinnerView :active="loading" color="danger"/>
                          <div class="d-flex align-items-center g-4">
                            <ButtonView type="normal" color="danger" class="w-100" @click="submit">
                              {{ translate("delete") }}
                            </ButtonView>
                            <ButtonView type="normal" color="secondary" class="w-100" @click="hide">
                              {{ translate("cancel") }}
                            </ButtonView>
                          </div>
                        </template>
                      </TargetedModalHttpFormView>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </template>
    </CollectionView>
    <ModalHttpFormView :endpoint="creating ? utilities.path('communities/@/roles', communityId) : utilities.path('roles/@', editing?.id)" :method="creating ? 'post' : 'put'" :content="creating ? undefined : editing" :active="creating || editing !== undefined" @update:active="creating = false; editing = undefined" @success="reload = true">
      <template v-slot:form="{ content, errors, submit, loading }">
        <div class="d-flex flex-column g-4">
          <InputView type="text" :min="1" :max="32" v-model:value="content.name" :title="translate('name')" :errors="errors.name" required/>
          <InputView type="color" v-model:value="content.color" :placeholder="translate('color')" :title="translate('color')" :errors="errors.color" required/>
          <div class="d-flex align-items-center g-4">
            <ButtonView type="normal" color="primary" class="w-100" @click="submit">
              {{ translate("save") }}
            </ButtonView>
            <ButtonView type="normal" color="secondary" class="w-100" @click="creating = false; editing = undefined">
              {{ translate("cancel") }}
            </ButtonView>
          </div>
          <SpinnerView :active="loading" color="primary"/>
        </div>
      </template>
    </ModalHttpFormView>
    <ModalView :active="viewing !== undefined" @update:active="viewing = undefined">
      <template v-slot:header>
        <div class="d-flex align-items-center justify-content-between">
          <h3 class="mb-0">{{ viewing.name }}</h3>
          <ModalCloseButtonView @click="viewing = undefined"/>
        </div>
      </template>
      <template v-slot:body>
        <div class="d-flex align-items-center g-2 mb-4">
          <ButtonView type="normal" color="secondary" @click="roleTab = 'permissions'" :active="roleTab === 'permissions'">
            <div class="d-flex align-items-center g-2">
              <i class="fa-duotone fa-list-ul"></i>
              <span>{{ translate("permissions") }}</span>
            </div>
          </ButtonView>
          <ButtonView type="normal" color="secondary" @click="roleTab = 'users'" :active="roleTab === 'users'">
            <div class="d-flex align-items-center g-2">
              <i class="fa-duotone fa-users"></i>
              <span>{{ translate("users") }}</span>
            </div>
          </ButtonView>
        </div>
        <RolePermissionsView v-if="roleTab === 'permissions'" :community-id="communityId" :role-id="viewing.id"/>
        <RoleUsersView v-else-if="roleTab === 'users'" :role-id="viewing.id"/>
      </template>
    </ModalView>
  </div>
</template>

<script setup>
import {InputView, CollectionView, utilities, ModalView, ButtonView, ModalCloseButtonView, TargetedModalHttpFormView, SpinnerView, ModalHttpFormView} from "@/niftybit";
import {ref} from "vue";
import RolePermissionsView from "@/systems/modules/roles/RolePermissionsView.vue";
import RoleUsersView from "@/systems/modules/roles/RoleUsersView.vue";

defineProps({
  communityId: String
});

const reload = ref(false);
const creating = ref(false);
const editing = ref(undefined);
const viewing = ref(undefined);
const roleTab = ref("permissions");

</script>